import React, {useContext} from 'react';
import {useNavigate} from 'react-router';
import {BridleContext} from '../BridleContextProvider';
import {handleCloseApp} from '../HelperFunctions';
import AddToCart from './AddToCart';

const ReviewActions = () => {
    const {setOptions, options, defaultOptions} = useContext(BridleContext);
    const navigate = useNavigate();
    const NO_PRODUCT_SELECTION_ID = -1;
    const bridlePieces = Object.assign({}, options);
    delete bridlePieces['Color'];

    const bridleItems = Object.values(bridlePieces)
        .map(item => item.productId)
        .filter(id => id > NO_PRODUCT_SELECTION_ID);

    function handleStartOver() {
        setOptions(defaultOptions);
        navigate('/');
    }
    return (
        <div className="button-container">
            <AddToCart products={bridleItems} />
            <div className="nav-direction button-row">
                <button className="secondary borderless button" onClick={handleStartOver}>
                    <span className="icon start-over">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M483.515 28.485L431.35 80.65C386.475 35.767 324.485 8 256 8 123.228 8 14.824 112.338 8.31 243.493 7.971 250.311 13.475 256 20.301 256h28.045c6.353 0 11.613-4.952 11.973-11.294C66.161 141.649 151.453 60 256 60c54.163 0 103.157 21.923 138.614 57.386l-54.128 54.129c-7.56 7.56-2.206 20.485 8.485 20.485H492c6.627 0 12-5.373 12-12V36.971c0-10.691-12.926-16.045-20.485-8.486zM491.699 256h-28.045c-6.353 0-11.613 4.952-11.973 11.294C445.839 370.351 360.547 452 256 452c-54.163 0-103.157-21.923-138.614-57.386l54.128-54.129c7.56-7.56 2.206-20.485-8.485-20.485H20c-6.627 0-12 5.373-12 12v143.029c0 10.691 12.926 16.045 20.485 8.485L80.65 431.35C125.525 476.233 187.516 504 256 504c132.773 0 241.176-104.338 247.69-235.493.339-6.818-5.165-12.507-11.991-12.507z"></path></svg>
                    </span>
                    Start Over
                </button>
                <button className="secondary button" onClick={handleCloseApp}>
                    Exit
                </button>
            </div>
        </div>
    );
};

export default ReviewActions;
